import { useEffect } from "react";

function PageTitle({ title }: { title: string }) {
  useEffect(() => {
    document.title = title + ' | Office of National Scholars'; // Update the document title
  }, [title]); // Re-run when the title changes

  return null; // No need to render anything
}

export default PageTitle;
